import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import Pagination from 'react-js-pagination';
import moment from 'moment';

import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  FormGroup,
  Button,
} from 'reactstrap';

import Header from 'components/Headers/Header.js';
import TaxServiceCategoryService from './TaxServiceCategoryService';

export default class ListTaxServiceCategories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      activePage: 1,
      itemsCountPerPage: 100,
      totalItemsCount: 0,
      pageRangeDisplayed: 5,
      search: '',
      loading: false,
    };
    this.deleteCategory = this.deleteCategory.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    this.fetchCategories(1);
  }

  fetchCategories(page) {
    this.setState({ loading: true });
    TaxServiceCategoryService.listCategories(page, 100, this.state.search)
      .then((response) => {
        this.setState({
          categories: response.data.data,
          itemsCountPerPage: response.data.perPage,
          totalItemsCount: response.data.totalData,
          activePage: response.data.currentPage,
          loading: false,
        });
      })
      .catch(() => this.setState({ loading: false }));
  }

  handlePageChange(pageNumber) {
    this.setState({ activePage: pageNumber }, () => this.fetchCategories(pageNumber));
  }

  handleSearchChange(e) {
    this.setState({ search: e.target.value }, () => this.fetchCategories(1));
  }

  deleteCategory(slug) {
    if (!window.confirm('Are you sure you want to delete this category?')) return;
    TaxServiceCategoryService.deleteCategory(slug)
      .then(() => {
        NotificationManager.success('Category deleted successfully!', 'Success!', 2000);
        this.fetchCategories(this.state.activePage);
      })
      .catch(() => NotificationManager.error('Failed to delete category.', 'Error', 2000));
  }

  render() {
    const { categories, loading } = this.state;

    return (
      <>
        <Header />
        <Container className="mt--7" fluid>
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Link to="/admin/tax-service/category/create">
                    <Button color="info">Add New Category +</Button>
                  </Link>
                </CardHeader>
                <CardHeader className="border-0">
                  <h3 className="mb-0">
                    Tax Service Categories
                    <FormGroup style={{ float: 'right' }}>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search here"
                        onChange={(e) => this.handleSearchChange(e)}
                      />
                    </FormGroup>
                  </h3>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Category</th>
                      <th scope="col">Description</th>
                      <th scope="col">Slug</th>
                      <th scope="col">Status</th>
                      <th scope="col">Created At</th>
                      <th scope="col" />
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="6" className="text-center">Loading...</td>
                      </tr>
                    ) : categories.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="text-center">No categories found.</td>
                      </tr>
                    ) : (
                      categories.map((cat) => (
                        <tr key={cat._id}>
                          <td>{cat.category}</td>
                          <td>{cat.description}</td>
                          <td>{cat.slug}</td>
                          <td>
                            <Badge color={cat.status ? 'success' : 'danger'}>
                              {cat.status ? 'Active' : 'Inactive'}
                            </Badge>
                          </td>
                          <td>{moment(cat.createdAt).format('MMM DD, YYYY')}</td>
                          <td className="text-right">
                            <UncontrolledDropdown>
                              <DropdownToggle
                                className="btn-icon-only text-light"
                                href="#pablo"
                                role="button"
                                size="sm"
                                color=""
                                onClick={(e) => e.preventDefault()}
                              >
                                <i className="fas fa-ellipsis-v" />
                              </DropdownToggle>
                              <DropdownMenu className="dropdown-menu-arrow" right>
                                <Link to={`/admin/tax-service/category/edit/${cat.slug}`}>
                                  <DropdownItem>Edit</DropdownItem>
                                </Link>
                                <DropdownItem
                                  href="#!"
                                  onClick={() => this.deleteCategory(cat.slug)}
                                >
                                  Delete
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
                <CardFooter className="py-4">
                  <nav aria-label="...">
                    <Pagination
                      activePage={this.state.activePage}
                      itemsCountPerPage={this.state.itemsCountPerPage}
                      totalItemsCount={this.state.totalItemsCount}
                      pageRangeDisplayed={this.state.pageRangeDisplayed}
                      onChange={this.handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </nav>
                </CardFooter>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}
